import React, { useState } from 'react';

import SinglePallet from './SinglePallet';

const Pallets = (props) => {
  const { currentOrder, actualizeOrder, requirements } = props;
  const { pallets } = currentOrder;

  const [opened, setOpened] = useState([]);

  const handleTogglePallet = (i) => {
    const newArr = opened.slice();
    const currentIndex = opened.indexOf(i);
    if (currentIndex === -1) {
      newArr.push(i);
    } else {
      newArr.splice(currentIndex, 1);
    }
    setOpened(newArr);
  };

  return (
    <>
      <div className="block-subtitle mb-1">Упакованные паллеты</div>

      <div className="packings-wrapper card-content">
        {pallets
          .sort((a, b) => a.num - b.num)
          .map((p, i) => (
            <SinglePallet
              key={`${p.barcode}-${i}`}
              {...p}
              requirements={requirements}
              data={p}
              isOpen={opened.indexOf(i) !== -1}
              onTogglePallet={() => handleTogglePallet(i)}
              currentOrder={currentOrder}
              actualizeOrder={actualizeOrder}
            />
          ))}
      </div>
    </>
  );
};

export default Pallets;
